<template>
  <v-btn
    v-blur v-click-outside="pause"
    class="justify-start"
    v-bind:class="{ pulse: isPlaying }"
    style="min-width: unset;"
    rounded
    @click="toggle"
    v-bind="$attrs" v-on="$listeners"
  >

    <audio v-if="isLoading || isPlaying" ref="preview" style="display: none;" :src="src" @ended="isPlaying = false" />

    <slot></slot>

    <v-progress-circular v-if="isLoading" indeterminate size="24" width="2" />
    <v-icon v-else v-html="isPlaying ? mdiPause : mdiPlay" />

    <span v-if="name" class="ml-2 pr-1 text-body-2" style="text-transform: none; font-weight: normal;">{{name}}</span>
  </v-btn>
</template>

<script>
import { mdiPause, mdiPlay } from '@mdi/js';


export default {
  name: 'audio-preview-btn',

  props: [ 'name', 'src' ],

  data() {
    return {
      isLoading: false,
      isPlaying: false
    };
  },

  created() {
    Object.assign(this, { mdiPause, mdiPlay })
  },

  methods: {
    play() {
      this.isLoading = true;
      this.$nextTick(() => this.$refs.preview.play().then(() => this.isPlaying = this.isLoading).finally(() => this.isLoading = false));
    },

    pause() {
      this.$refs.preview?.pause();
      this.isLoading = false;
      this.isPlaying = false;
    },

    toggle() {
      if (this.isLoading || this.isPlaying)
        this.pause();
      else
        this.play();
    }
  }
}
</script>
